export default [
    {
        path: 'listagem',
        component: () => import('@/views/transporte-paciente/listagem/Index'),
        redirect: 'listagem/list',
        children: [
            {
                name: 'listagem-list',
                path: 'list',
                component: () => import('@/views/transporte-paciente/listagem/List.vue'),
            },
        ],
    },
]